import React, { FunctionComponent } from 'react'
import { Button, ButtonProps, DesignLanguage, Grid, useIsDesignLanguage } from '@afterpaytouch/core'
import { useTranslation } from '../../../utils/convergence'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useEnableOTP } from '../../../state'

export const OTPButton: FunctionComponent<ButtonProps> = ({ loading, onClick, disabled }) => {
  const { t } = useTranslation()
  const { enableOTP } = useEnableOTP()
  const { buttonSize } = useCheckoutSizes()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)

  if (!enableOTP) {
    return null
  }

  return (
    <Grid.Item sm={12}>
      <Button
        kind={isArcadeDesignLanguage ? 'Secondary' : 'Ghost'}
        loading={loading}
        onClick={onClick}
        size={buttonSize}
        testNameSpace='login-otp'
        disabled={disabled}
        padding='Fluid'
      >
        {t('password:otp')}
      </Button>
    </Grid.Item>
  )
}
